import $ from "jquery";
const cta = {
  methods: {
    buttonClickHandler: function () {
     $('.chli-cta').on('click', function(){
            const currentBtn = $(this).text().replace(/\s+/g, ' ').trim();
             let heading;
            heading = $(this).parents('.genericContainer').prev('.genericContainer').prev('.genericContainer').find('.chlititle').text().replace(/\s+/g, ' ').trim();
            if(heading==""){
            heading=$(this).closest('.genericContainer').find('.chlititle').text().replace(/\s+/g, ' ').trim();
            }
            var obj = cta.methods.dataLayerObj(currentBtn,heading);
            createDataLayer("buttonClick", obj);
          });
        },
    dataLayerObj: function (e,el) {
      var obj = {
                     'articleName' : "",
                     'blogCategory' : "",
                     'blogPageCategory' : "",
                     'buttonText' : e ? e : "",
                     'pageSection' : el ? el : "",
                     'planOption' : "",
                     'pageType' : document.querySelector("meta[name='template']").content == 'chli-clp-template' ? "Campaign":"Other page",
                     'productCategory' : "",
                     'PageSubCategory': "",
                     'productName' : "",
                     'question' : "",
                     'searchTerm' : "",
                     'videoTitle' : "",
                     'bannerName' : "",
                     'bannerType' : "",
                     'leadForm' : "",
                 };
                 return obj;
             }
  }
};

$(document).ready(function () {
  cta.methods.buttonClickHandler();
});
